import type { RootState } from '@/app/store';

export const selectBulkImportsHistoryState = (state: RootState) =>
  state.bulkImportsHistory;

export const selectBulkImportsHistoryRows = (state: RootState) =>
  state.bulkImportsHistory.rows;

export const selectBulkImportsHistoryLoading = (state: RootState) =>
  state.bulkImportsHistory.loading;

export const selectBulkImportsHistoryError = (state: RootState) =>
  state.bulkImportsHistory.error;

export const selectBulkImportsHistoryQuery = (state: RootState) =>
  state.bulkImportsHistory.query;
